import * as React from 'react'
import { EmptyList } from '../EmptyList'
import { GenericTableBody } from './GenericTableBody'
import { GenericTableHeader } from './GenericTableHeader'
import './styles.scss'

export type ColumnDefinitionType<T, K extends keyof T> = {
  key: K
  header: any
  width?: string
  isSortable?: boolean
  gridArea?: string
  checkbox?: boolean
  radio?: boolean
  selected?: any
  filter?: boolean
  input?: boolean
}

type TableProps<T, K extends keyof T> = {
  data?: T[] | undefined
  columns: ColumnDefinitionType<T, K>[]
  onRowClicked?: (data: ColumnDefinitionType<T, K>) => void
  checked?: boolean
  onActionRadio?: (active: boolean) => void
}

export const GenericTable = <
  T extends { id: number | string },
  K extends keyof T,
>({
  data = [],
  columns,
  onRowClicked,
  onActionRadio,
}: TableProps<T, K>) => (
  <div className="generic-table">
    <GenericTableHeader columns={columns} {...{ onActionRadio }} checked />
    {data?.length ? (
      <GenericTableBody
        data={data}
        columns={columns}
        onRowClicked={onRowClicked}
      />
    ) : (
      <EmptyList text="Nenhum resultado encontrado" />
    )}
  </div>
)
